export class LanguageEntity {
  idLanguageEntity: number;
  name: string;
  orphan: boolean;

  constructor(
    idLanguageEntity: number,
    name: string,
    orphan: boolean,
  ) {
    this.idLanguageEntity = idLanguageEntity;
    this.name = name;
    this.orphan = orphan;
  }

  static fromRaw(raw: any): LanguageEntity {
    return new LanguageEntity(
      Number(raw.idLanguageEntity),
      String(raw.name),
      Boolean(raw.orphan),
    );
  }

  clone(): LanguageEntity {
    return new LanguageEntity(
      this.idLanguageEntity,
      this.name,
      this.orphan,
    );
  }

  toPayload(): any {
    return {
      idLanguageEntity: this.idLanguageEntity,
      name: this.name,
      orphan: this.orphan,
    };
  }
}
